<template>
	<el-card class="menuBody" shadow="never">
		<left-project-tree @chooseNode="selectNode" style="height: 100%; overflow: auto;"></left-project-tree>
		<div class="menuTool" style="width:100%;">
			<el-card class="box-card">
				<el-row :gutter="10">
					<div class="search-title">
						月卡车列表
					</div>
					<div class="search-input-item">
						<el-select ref="parkEle" clearable size="small" v-model="query.parkId" placeholder="车场">
							<el-option v-for="item in parks" :key="item.parkId" :label="item.parkName" :value="item.parkId" clearable></el-option>
						</el-select>
					</div>
					<div class="search-input-item">
						<el-input size="small" v-model="query.plateNumber" placeholder="车牌号" clearable></el-input>
					</div>
					<div class="search-input-item">
						<el-input size="small" v-model="query.owner" placeholder="车主姓名" clearable></el-input>
					</div>

					<div class="search-button-tools">
						<el-button size="small" type="primary" :loading="tableLoading" @click="doSearch">查询</el-button>
						<el-button size="small" type="primary" :disabled="!query.parkId" @click="doRegistry">新车登记</el-button>
						<!-- <el-button size="small" type="primary" :disabled="!query.parkId" @click="doOfflineModifyCarNo">线下车牌修改</el-button> -->
					</div>

					<el-table
						:data="tableData"
						@selection-change="handleSelectionChange"
						row-key="cardId"
						border
						v-loading="tableLoading"
						tooltip-effect="light"
						:stripe="true"
					>
						<el-table-column width="150" show-overflow-tooltip prop="parkName" label="车场"></el-table-column>
						<el-table-column width="150" show-overflow-tooltip prop="plateNumber" label="车牌" align="right">
							<template slot-scope="scope">
								{{ scope.row.plateNumber }}
								<el-button @click="doModifyCardNo(scope.row)" type="text" size="small">车牌修改</el-button>
							</template>
						</el-table-column>
						<el-table-column width="100" show-overflow-tooltip prop="owner" label="车主"></el-table-column>
						<el-table-column width="150" show-overflow-tooltip prop="phoneNumber" label="手机号"></el-table-column>
						<el-table-column width="100" label="证照">
							<template slot-scope="scope">
								<el-button @click="doLookImage(scope.row)" type="text" size="small">查看</el-button>
							</template>
						</el-table-column>
						<el-table-column width="200" show-overflow-tooltip prop="carState" label="车辆状态">
							<template slot-scope="scope">
								<label v-show="scope.row.carState == 0 || !scope.row.carState">正常续费</label>
								<label v-show="scope.row.carState == 1" style="color:#f00;">停止续费</label>
								<label v-show="scope.row.carState == 2" style="color:#a00;">暂停续费</label>
								<el-button v-show="scope.row.carState != 1" @click="forbiddenRenew(scope.row)" type="text" size="small"
									>禁止续费</el-button
								>
								<el-button v-show="scope.row.carState == 1" @click="allowRenew(scope.row)" type="text" size="small"
									>允许续费</el-button
								>
							</template>
						</el-table-column>
						<el-table-column width="150" show-overflow-tooltip prop="carType" label="车辆类型">
							<template slot-scope="scope">
								<label>{{ scope.row.carType | dictLabel(carType) }}</label>
							</template>
						</el-table-column>
						<el-table-column width="450" show-overflow-tooltip label="有效期" align="right">
							<template slot-scope="scope">
								<span>{{ scope.row.beginTime | dateFmt("YYYY-MM-DD") }}</span>
								至
								<span>{{ scope.row.endTime | dateFmt("YYYY-MM-DD") }}</span>
								<el-button @click="syncByLocalDate(scope.row)" type="text" size="small">同步车禁</el-button>
								<el-button @click="carDateEdit(scope.row)" type="text" size="small">有效期修改</el-button>
							</template>
						</el-table-column>
						<el-table-column width="200" show-overflow-tooltip label="续费起始日" align="right">
							<template slot-scope="scope">
								<span>{{ scope.row.renewDate | dateFmt("YYYY-MM-DD") }}</span>
								<el-button @click="carNewStartDate(scope.row)" type="text" size="small">指定</el-button>
							</template>
						</el-table-column>
						<el-table-column width="120" prop="parkingLot" label="车位号"></el-table-column>
						<!-- <el-table-column width="120" prop="nonMotorNo" label="非机动车卡号"></el-table-column> -->
						<el-table-column width="180" show-overflow-tooltip="" prop="roomInfo" label="房产"></el-table-column>
						<el-table-column width="100" prop="bindState" label="解绑状态" align="right">
							<template slot-scope="scope">
								<label :style="{ color: scope.row.bindState == 1 ? 'red' : '' }">{{
									scope.row.bindState | dictLabel(bindState)
								}}</label>
							</template>
						</el-table-column>
						<el-table-column width="250px" fixed="right" label="操作">
							<template slot-scope="scope">
								<el-button @click="doLook(scope.row)" type="text" size="small">查看</el-button>
								<!-- <el-button v-show="scope.row.renewState == 0" @click="doRenewal(scope.row)" type="text" size="small">续费</el-button>
								<el-button v-show="scope.row.isPropertySync == 1" @click="doSyncPropertyFee(scope.row)" type="text" size="small"
									>同步物业费</el-button
								> -->
								<el-button v-show="scope.row.bindState != 1" @click="doUnbind(scope.row)" type="text" size="small">解绑</el-button>
								<!-- <el-button @click="doOnlineSync(scope.row)" type="text" size="small">线上同步</el-button> -->
								<!-- <el-button @click="doBicycleAccessCard(scope.row)" type="text" size="small">非机动车卡号</el-button> -->
							</template>
						</el-table-column>
					</el-table>
					<simple-pagination @search="doSearch" />
				</el-row>
			</el-card>
		</div>
		<!-- DLG Begin -->
		<!-- 车牌修改 -->
		<el-dialog
			:title="modifyCarNoDlg.title"
			:visible.sync="modifyCarNoDlg.visible"
			v-if="modifyCarNoDlg.visible"
			:destroy-on-close="true"
			width="500px"
			center
		>
			<modify-car-no-form :defaultFormData="modifyCarNoDlg.formData" @search="doSearch"></modify-car-no-form>
		</el-dialog>

		<!-- 有效期修改 -->
		<el-dialog
			:title="modifyValidDateDlg.title"
			:visible.sync="modifyValidDateDlg.visible"
			v-if="modifyValidDateDlg.visible"
			:destroy-on-close="true"
			width="500px"
			center
		>
			<modify-valid-date-form :defaultFormData="modifyValidDateDlg.formData" @search="doSearch"></modify-valid-date-form>
		</el-dialog>

		<!-- 续费指定 -->
		<el-dialog
			:title="modifyRenewalDateDlg.title"
			:visible.sync="modifyRenewalDateDlg.visible"
			v-if="modifyRenewalDateDlg.visible"
			:destroy-on-close="true"
			width="600px"
			center
		>
			<modify-renewal-date-form :defaultFormData="modifyRenewalDateDlg.formData" @search="doSearch"></modify-renewal-date-form>
		</el-dialog>

		<!-- 非机动车门禁卡号 -->
		<el-dialog
			:title="bicycleAccessCardDlg.title"
			:visible.sync="bicycleAccessCardDlg.visible"
			v-if="bicycleAccessCardDlg.visible"
			:destroy-on-close="true"
			width="500px"
			center
		>
			<bicycle-access-card-form :defaultFormData="bicycleAccessCardDlg.formData" @search="doSearch"></bicycle-access-card-form>
		</el-dialog>

		<!-- 证照查看 -->
		<el-dialog
			:title="imageViewDlg.title"
			:visible.sync="imageViewDlg.visible"
			v-if="imageViewDlg.visible"
			:destroy-on-close="true"
			width="500px"
			center
		>
			<image-view-dlg :defaultFormData="imageViewDlg.formData"></image-view-dlg>
		</el-dialog>

		<!-- 非固定车位登记 -->
		<el-dialog
			:title="newCarRegistryDlg.title"
			:visible.sync="newCarRegistryDlg.visible"
			v-if="newCarRegistryDlg.visible"
			:destroy-on-close="true"
			width="850px"
			center
		>
			<new-car-registry-form :defaultFormData="newCarRegistryDlg.formData" @search="doSearch"></new-car-registry-form>
		</el-dialog>

		<!-- 查看详情 -->
		<el-dialog :title="detailDlg.title" :visible.sync="detailDlg.visible" v-if="detailDlg.visible" :destroy-on-close="true" width="80%" center>
			<detail :defaultFormData="detailDlg.formData"></detail>
		</el-dialog>
		<!-- DLG End -->
	</el-card>
</template>
<script>
import "@/assets/scss/common.scss";
import mixin from "@/mixin/index";
import { carType, bindState } from "@/dict/carDict";
import { pick, omit, assign } from "lodash";
import { get, post, alertMultiMessage, alertSingleMessage } from "@/assets/common/request";
import ModifyCarNoForm from "./components/ModifyCarNoForm.vue";
import ModifyValidDateForm from "./components/ModifyValidDateForm.vue";
import ModifyRenewalDateForm from "./components/ModifyRenewalDateForm.vue";
import BicycleAccessCardForm from "./components/BicycleAccessCardForm.vue";
import ImageViewDlg from "../ImageViewDlg.vue";
import NewCarRegistryForm from "./components/NewCarRegistryForm.vue";
import Detail from "./components/Detail.vue";
import LeftProjectTree from "@/components/LeftProjectTree.vue";
import moment from "moment";

export default {
	name: "MonthCardList",
	mixins: [mixin],
	components: {
		LeftProjectTree,
		ModifyCarNoForm,
		ModifyValidDateForm,
		ModifyRenewalDateForm,
		BicycleAccessCardForm,
		ImageViewDlg,
		NewCarRegistryForm,
		Detail,
	},
	data() {
		return {
			carType,
			bindState,
			queryListUrl: "/car/web/carManage/cards",
			parks: [],
			modifyCarNoDlg: {
				title: "车牌修改",
				visible: false,
				formData: { plateNumber: "" },
			},
			modifyValidDateDlg: {
				title: "指定有效期",
				visible: false,
				formData: {},
			},
			modifyRenewalDateDlg: {
				title: "指定续费开始日",
				visible: false,
				formData: {},
			},
			bicycleAccessCardDlg: {
				title: "非机动车门禁卡号",
				visible: false,
				formData: {},
			},
			imageViewDlg: {
				title: "查看",
				visible: false,
				formData: {},
			},
			newCarRegistryDlg: {
				title: "非固定车位登记",
				visible: false,
				formData: {},
			},
			detailDlg: {
				title: "车辆信息详情",
				visible: false,
				formData: {},
			},
		};
	},
	methods: {
		doSearch() {
			this.getListPost();
		},
		doRegistry() {
			assign(this.newCarRegistryDlg, {
				visible: true,
				formData: {
					projectId: this.query.projectId,
					parkId: this.$refs.parkEle.selected.value,
					parkName: this.$refs.parkEle.selected.label,
					carType: 1,
                    userType: 0,
					regTime: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
				},
			});
		},
		/**
		 * 线下车牌修改
		 */
		doOfflineModifyCarNo() {
			assign(this.modifyCarNoDlg, {
				visible: true,
				formData: { plateNumber: "" },
			});
		},
		/**
		 * 车牌修改
		 */
		doModifyCardNo(row) {
			assign(this.modifyCarNoDlg, {
				visible: true,
				formData: {
					cardId: row.cardId,
					oldPlateNumber: row.plateNumber,
				},
			});
		},
		/**
		 * 查看证照
		 */
		doLookImage(row) {
			const url = `/car/web/carManage/photo/${row.cardId}`;
			get(url).then((res) => {
				const data = res.data;
				if (data) {
					if (data.photo) {
						const imagesUrl = data.photo.split(",").filter((e) => e);
						assign(this.imageViewDlg, {
							visible: true,
							formData: { imagesUrl: imagesUrl },
						});
					}else {
                        this.$message("没有证照信息");
                    }
				}else {
                    this.$message.error("服务器返回数据错误");
                }
			});
		},
		/**
		 * 禁止续费
		 */
		forbiddenRenew(row) {
			this._tip("您确认要禁止车辆线上续费吗？", () => {
				const url = "/car/web/carManage/isRenew";
				const params = {
					cardId: row.cardId,
					isPermitRenew: 1,
				};
				post(url, params).then((data) => {
					alertSingleMessage(data);
					this.doSearch();
				});
			});
		},
		/**
		 * 允许续费
		 */
		allowRenew(row) {
			this._tip("您确认要允许车辆线上续费吗？", () => {
				const url = "/car/web/carManage/isRenew";
				const params = {
					cardId: row.cardId,
					isPermitRenew: 0,
				};
				post(url, params).then((data) => {
					alertSingleMessage(data);
					this.doSearch();
				});
			});
		},
		/**
		 * 同步车禁
		 */
		syncByLocalDate(row) {
			this._tip("您确认要同步有效期到云平台吗？", () => {
				const url = "/car/web/carManage/card/sendSync";
				const params = {
					cardId: row.cardId,
				};
				get(url, params).then((data) => {
					alertSingleMessage(data);
					this.doSearch();
				});
			});
		},
		/**
		 * 修改有效期
		 */
		carDateEdit(row) {
			assign(this.modifyValidDateDlg, {
				visible: true,
				formData: {
					beginTime: row.beginTime,
					endTime: row.endTime,
					cardId: row.cardId,
				},
			});
		},
		/**
		 * 指定续费起始日期
		 */
		carNewStartDate(row) {
			assign(this.modifyRenewalDateDlg, {
				visible: true,
				formData: {
					startTime: row.renewDate,
					nextStartTime: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
					cardId: row.cardId,
				},
			});
		},
		/**
		 * 查看
		 */
		doLook(row) {
			assign(this.detailDlg, {
				visible: true,
				formData: { cardId: row.cardId },
			});
		},
		/**
		 * 续费
		 */
		doRenewal(row) {},
		/**
		 * 同步物业费
		 */
		doSyncPropertyFee(row) {},
		/**
		 * 解绑
		 */
		doUnbind(row) {
			this._tip("您确认解绑该车辆吗？(仅app上解绑，云平台不影响)", () => {
				const url = "/car/web/carManage/card/unbind";
				const params = {
					cardId: row.cardId,
				};
				post(url, params).then((data) => {
					alertSingleMessage(data);
					this.doSearch();
				});
			});
		},
		/**
		 * 线上同步
		 */
		doOnlineSync(row) {
			this._tip("您确认要同步云平台有效期到CIM吗？", () => {
				const url = "/car/web/carManage/card/rcvSync";
				const params = {
					cardId: row.cardId,
				};
				get(url, params).then((data) => {
					alertSingleMessage(data);
					this.doSearch();
				});
			});
		},
		/**
		 * 非机动车卡号
		 */
		doBicycleAccessCard(row) {
			assign(this.bicycleAccessCardDlg, {
				visible: true,
				formData: {
					cardId: row.cardId,
				},
			});
		},
		/**
		 * 加载车场
		 */
		loadParks() {
			const url = "/car/web/common/parkList";
			const params = {
				projectId: this.query.projectId,
			};
			get(url, params).then((res) => {
				const data = res.data;
				this.parks = data;
			});
		},
		selectNode(data) {
			this.query = assign(this.query, data);
			this.doSearch();
			this.loadParks();
		},
	},
	mounted() {
		this.doSearch();
	},
};
</script>
